import { createSlice } from "@reduxjs/toolkit";
import { FilterPanelEnum } from "./filterPanel.enum";


export type ManualFilterType = {
  wirelessSystemIdList: number[],
  frequencyFrom: string | null,
  frequencyTo: string | null,
  technologyConfigurationIdList: number[],
}

export type CoordinatesFilter = {
  x: number | null,
  y: number | null,
  longitude: number | null,
  latitude: number | null,
  radius: string,
}

type FilterState = {
  influenceAreaEnabled: boolean;
  showIndoorDeviceList: boolean;
  filterPanelShown: FilterPanelEnum | null;
  manualFilters: ManualFilterType | null,
  coverageSettings: {
    powerLossCoefficient: number | null,
    interferenceLevel: number | null,
  },
  smartFilterDeviceIdList: number[];
  coordinatesFilter: CoordinatesFilter;
  filtersAppliedForMapId: number | null;
}

const emptyCoordinatesFilter = {
  x: null,
  y: null,
  longitude: null,
  latitude: null,
  radius: '',
}

const initialState: FilterState = {
  influenceAreaEnabled: true,
  showIndoorDeviceList: false,
  filterPanelShown: null,
  smartFilterDeviceIdList: [],
  manualFilters: null,
  coordinatesFilter: emptyCoordinatesFilter,
  coverageSettings: {
    powerLossCoefficient: null,
    interferenceLevel: null,
  },
  filtersAppliedForMapId: null,
}

export const filterSlice = createSlice({
  name: 'filterState',
  initialState,
  reducers: {
    setInfluenceAreaEnabled: (state, action) => {
      state.influenceAreaEnabled = !!action.payload;
    },
    setShowIndoorDeviceList: (state, action) => {
      state.showIndoorDeviceList = !!action.payload;
    },
    setSmartFilterDeviceIdList: (state, action) => {
      state.smartFilterDeviceIdList = action.payload || [];
    },
    setCoordinatesFilter: (state, action) => {
      if (!action.payload) {
        state.coordinatesFilter = emptyCoordinatesFilter;
        return;
      }

      state.coordinatesFilter = { ...state.coordinatesFilter, ...action.payload };
    },
    setFiltersMapId: (state, action) => {
      state.filtersAppliedForMapId = action.payload;
    },
    setFilterPanelVisibility: (state, action) => {
      state.filterPanelShown = action.payload;
    },
    setManualFilters: (state, action) => {
      state.manualFilters = action.payload;
    },
    setCoverageSettings: (state, action) => {
      const { interferenceLevel, powerLossCoefficient } = action.payload;

      state.coverageSettings = {
        interferenceLevel: !interferenceLevel ? null : parseFloat(interferenceLevel),
        powerLossCoefficient: !powerLossCoefficient ? null : parseFloat(powerLossCoefficient),
      };
    }
  }
});

export const {
  setInfluenceAreaEnabled,
  setShowIndoorDeviceList,
  setSmartFilterDeviceIdList,
  setCoordinatesFilter,
  setFiltersMapId,
  setFilterPanelVisibility,
  setManualFilters,
  setCoverageSettings,
} = filterSlice.actions;